import { countLineBreaks } from './common';
import { Input } from 'rsuite';
import React from 'react';
import { InputProps } from 'rsuite/esm/Input/Input';

type Props = {
  minRows?: number;
  maxRows?: number;
  value: string;
  onChange: InputProps['onChange'];
  placeholder?: string;
  style?: React.CSSProperties;
};

export default function DynamicTextArea({
  value,
  onChange,
  placeholder,
  style,
  minRows = 3,
  maxRows = 7,
}: Props) {
  return (
    <Input
      as="textarea"
      rows={Math.min(
        maxRows,
        Math.max(
          minRows,
          value?.includes('\n')
            ? countLineBreaks(value) + 1
            : 1 + Math.round((value?.length || 0) / 31)
        )
      )}
      placeholder={placeholder}
      value={value || ''}
      style={style}
      onChange={onChange}
    />
  );
}
